// Shared by the body map and the movers list: the same per-muscle current /
// previous record, and the labels the library's muscle ids print as.
export const LIBRARY_MUSCLE_LABELS = {
  "chest":           "Chest",
  "upper-back":      "Upper Back",
  "lower-back":      "Lower Back",
  "trapezius":       "Traps",
  "front-deltoids":  "Front Delts",
  "back-deltoids":   "Rear Delts",
  "biceps":          "Biceps",
  "triceps":         "Triceps",
  "forearm":         "Forearms",
  "abs":             "Abs",
  "obliques":        "Obliques",
  "quadriceps":      "Quads",
  "hamstring":       "Hamstrings",
  "gluteal":         "Glutes",
  "calves":          "Calves",
  "abductors":       "Abductors",
  "adductor":        "Adductors",
  "neck":            "Neck",
};

// Merge the current and previous period counts into one per-muscle record.
export function buildMuscleStats(current, previous) {
  const stats = new Map();
  const touch = (muscle) => {
    if (!stats.has(muscle)) stats.set(muscle, { muscle, setCount: 0, prevSetCount: 0, delta: 0 });
    return stats.get(muscle);
  };
  for (const { muscle, setCount } of current || []) touch(muscle).setCount = setCount;
  for (const { muscle, setCount } of previous || []) touch(muscle).prevSetCount = setCount;
  for (const entry of stats.values()) entry.delta = entry.setCount - entry.prevSetCount;
  return stats;
}

export function signed(value) {
  return value > 0 ? `+${value}` : `${value}`;
}

